import { useGlobalContext } from "../../../../Context/Context";
import { useEffect, useMemo, useState, useCallback } from "react";
import axios from "axios";
import TabelaZaposleni from "./TabelaZaposleni";
import PreviewZaposlen from "./PreviewZaposlen";
import Button from "../../../Custom/Button/Button";
import Obrazac6Zaposlen from "./Obrazac6Zaposlen";
import TestBZR from "./TestBZR";
import Zapisnik from "./Zapisnik";
import IDKarticaZaposlen from "./IdKarticaZaposlen";

const API_URL = "https://data.nadzor.app/api/zaposleni/read.php";

const styles = {
  btn: { padding: "5px 15px", fontWeight: "bold" },
};

function DokumentaZaposlenih() {
  const [currentState, setCurrentState] = useState("AKTIVAN");
  const [zaposlenId, setZaposlenId] = useState("");
  const [zaposleni, setZaposleni] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editDataZaposlen, setEditDataZaposlen] = useState(null);
  const [isOpenObrazac6, setIsOpenObrazac6] = useState(false);
  const [isOpenTestBZR, setIsOpenTestBZR] = useState(false);
  const [isOpenZapisnik, setIsOpenZapisnik] = useState(false);
  const [isOpenIDKartica, setIsOpenIDKartica] = useState(false);
  const [lookups, setLookups] = useState({
    zaposleni: [],
    radna_mesta: [],
    lzo: [],
    mere: [],
  });

  const {
    dictionary,
    dokumentaZaposlenihPretraga,
    setDokumentaZaposlenihPretraga,
    setEditZaposlenData,
    loggedUser,
    apiKey,
    selectedMainEntity,
    baseUrl,
  } = useGlobalContext();

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    axios
      .post(`${baseUrl}/evidencija6/get_lookups.php`, {
        company_id: selectedMainEntity.company_id,
      })
      .then(({ data }) => {
        if (data.status === 200) setLookups(data);
      });
  }, [selectedMainEntity?.company_id]);

  const fetchZaposleni = useCallback(async () => {
    if (!loggedUser) return;
    setLoading(true);
    try {
      const response = await axios.post(API_URL, {
        api_key: apiKey,
        user_id: loggedUser.id || "",
        company_id: selectedMainEntity.company_id,
      });
      if (response.data && response.data.status === 200) {
        setZaposleni(
          Array.isArray(response.data.data) ? response.data.data : [],
        );
      } else {
        setZaposleni([]);
      }
    } catch (error) {
      console.error("Greška:", error);
      setZaposleni([]);
    } finally {
      setLoading(false);
    }
  }, [loggedUser]);

  // Slušaj event za uspešno čuvanje novog/izmenjenog zaposlenog
  useEffect(() => {
    const handleRefresh = () => {
      fetchZaposleni();
    };

    window.addEventListener("zaposleniSaved", handleRefresh);
    return () => window.removeEventListener("zaposleniSaved", handleRefresh);
  }, [fetchZaposleni]);

  useEffect(() => {
    fetchZaposleni();
  }, [fetchZaposleni]);

  useEffect(() => {
    const onModeChange = (e) => {
      const mode = e?.detail?.mode;
      if (!mode) return;
      setSelectedRows([]);
      setZaposlenId("");
      if (mode === "AKTIVNI") setCurrentState("AKTIVAN");
      else if (mode === "ARHIVIRANI") setCurrentState("NEAKTIVAN");
      else setCurrentState(mode);
    };
    window.addEventListener("zaposleniViewChange", onModeChange);
    return () =>
      window.removeEventListener("zaposleniViewChange", onModeChange);
  }, []);

  useEffect(() => {
    const frontendMode = currentState === "AKTIVAN" ? "AKTIVNI" : "ARHIVIRANI";
    window.dispatchEvent(
      new CustomEvent("zaposleniViewSync", { detail: { mode: frontendMode } }),
    );
  }, [currentState]);

  const handleNazad = () => {
    setZaposlenId("");
    setSelectedRows([]);
    setCurrentState("AKTIVAN");
    setEditDataZaposlen(null);
    setEditZaposlenData(null);
    setDokumentaZaposlenihPretraga({
      radnoMesto: { id: "-1", name: "" },
      istekDokumenta: { id: "-1", name: "" },
      poslovnaJedinica: { id: "-1", name: "" },
      pretraga: "",
    });
  };

  const handleArchiveSelected = async () => {
    if (selectedRows.length === 0) return;
    if (window.confirm("Arhivirati " + selectedRows.length + " zaposlenih?")) {
      try {
        const res = await axios.post(
          "https://data.nadzor.app/api/zaposleni/archive.php",
          {
            api_key: apiKey,
            user_id: loggedUser.id,
            ids: selectedRows,
          },
        );
        if (res.data.status === 200) {
          alert("Uspešno arhivirano!");
          fetchZaposleni();
          setSelectedRows([]);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleRestoreSelected = async () => {
    if (selectedRows.length === 0) return;
    if (
      window.confirm(
        "Vratiti " + selectedRows.length + " zaposlenih u aktivne?",
      )
    ) {
      try {
        const res = await axios.post(
          "https://data.nadzor.app/api/zaposleni/restore.php",
          {
            api_key: apiKey,
            user_id: loggedUser.id,
            ids: selectedRows,
          },
        );
        if (res.data.status === 200) {
          fetchZaposleni();
          setSelectedRows([]);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleDeleteSelected = async () => {
    if (selectedRows.length === 0) return;
    if (
      window.confirm(
        "TRAJNO obrisati " +
          selectedRows.length +
          " zaposlenih? Ova akcija se ne može poništiti!",
      )
    ) {
      try {
        const res = await axios.post(
          "https://data.nadzor.app/api/zaposleni/delete.php",
          {
            api_key: apiKey,
            user_id: loggedUser.id,
            ids: selectedRows,
          },
        );
        if (res.data.status === 200) {
          fetchZaposleni();
          setSelectedRows([]);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  const filtriraniZaposleni = useMemo(() => {
    if (editDataZaposlen) return [editDataZaposlen];
    let filtered = zaposleni.filter((z) => z.status === currentState);
    const { radnoMesto, istekDokumenta, poslovnaJedinica, pretraga } =
      dokumentaZaposlenihPretraga;
    if (radnoMesto?.id && radnoMesto.id !== "-1" && radnoMesto.id !== "sve")
      filtered = filtered.filter((z) => z.radnoMesto === radnoMesto.name);
    if (
      poslovnaJedinica?.id &&
      poslovnaJedinica.id !== "-1" &&
      poslovnaJedinica.id !== "sve"
    )
      filtered = filtered.filter(
        (z) => z.poslovnaJedinica === poslovnaJedinica.name,
      );
    if (
      istekDokumenta?.id &&
      istekDokumenta.id !== "-1" &&
      istekDokumenta.id !== "sve"
    ) {
      const istekId = istekDokumenta.id;
      filtered = filtered.filter((z) => {
        const statusi = [z.ug, z.lk, z.lz, z.o6, z.dr, z.et].filter(Boolean);
        if (istekId === "1") return statusi.includes("wrong");
        if (istekId === "2") return statusi.includes("notif");
        if (istekId === "3")
          return !statusi.includes("wrong") && !statusi.includes("notif");
        return true;
      });
    }
    if (pretraga) {
      const term = pretraga.toLowerCase();
      filtered = filtered.filter(
        (z) =>
          z.ime.toLowerCase().includes(term) ||
          z.prezime.toLowerCase().includes(term),
      );
    }
    return filtered;
  }, [zaposleni, currentState, dokumentaZaposlenihPretraga, editDataZaposlen]);

  if (isOpenObrazac6)
    return (
      <Obrazac6Zaposlen
        zaposlen={editDataZaposlen}
        handleZatvori={() => setIsOpenObrazac6(false)}
        lookups={lookups}
      />
    );

  if (isOpenTestBZR)
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: "20px",
          backgroundColor: "#f9f9f9",
          border: "1.5px solid #9f9f9f",
          overflow: "auto",
        }}
      >
        <TestBZR
          zaposlen={editDataZaposlen}
          handleZatvori={() => setIsOpenTestBZR(false)}
          onSaved={fetchZaposleni}
        />
      </div>
    );

  if (isOpenZapisnik)
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: "20px",
          backgroundColor: "#f9f9f9",
          border: "1.5px solid #9f9f9f",
          overflow: "auto",
        }}
      >
        <Zapisnik
          zaposlen={editDataZaposlen}
          handleZatvori={() => setIsOpenZapisnik(false)}
          onSaved={fetchZaposleni}
        />
      </div>
    );

  if (isOpenIDKartica)
    return (
      <IDKarticaZaposlen
        zaposlen={editDataZaposlen}
        handleZatvori={() => setIsOpenIDKartica(false)}
      />
    );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          padding: "25px",
          backgroundColor: "#f9f9f9",
          height: "80%",
          overflow: "auto",
          border: "1.5px solid #9f9f9f",
        }}
      >
        {loading ? (
          <div>Учитавање...</div>
        ) : (
          <>
            {!zaposlenId && (
              <TabelaZaposleni
                data={filtriraniZaposleni}
                setZaposlenId={setZaposlenId}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                editDataZaposlen={editDataZaposlen}
                setEditDataZaposlen={setEditDataZaposlen}
              />
            )}
            {zaposlenId && (
              <PreviewZaposlen
                zaposlenId={zaposlenId}
                setZaposlenId={setZaposlenId}
              />
            )}
          </>
        )}
      </div>

      <div
        className="tasteri-tabele"
        style={{ display: "flex", flexDirection: "column", gap: "10px" }}
      >
        {!editDataZaposlen && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <Button style={{ ...styles.btn, width: "230px" }}>
                {dictionary["stampaj"]}
              </Button>
              <Button style={{ ...styles.btn, width: "230px" }}>
                {dictionary["posalji"]}
              </Button>
            </div>
            {selectedRows.length > 0 && (
              <div style={{ display: "flex", gap: "10px" }}>
                {currentState === "AKTIVAN" ? (
                  <div onClick={handleArchiveSelected}>
                    <Button
                      style={{
                        ...styles.btn,
                        backgroundColor: "orange",
                        color: "white",
                      }}
                    >
                      АРХИВИРАЈ ({selectedRows.length})
                    </Button>
                  </div>
                ) : (
                  <>
                    <div onClick={handleRestoreSelected}>
                      <Button
                        style={{
                          ...styles.btn,
                          backgroundColor: "green",
                          color: "white",
                        }}
                      >
                        ВРАТИ У АКТИВНЕ ({selectedRows.length})
                      </Button>
                    </div>
                    <div onClick={handleDeleteSelected}>
                      <Button
                        style={{
                          ...styles.btn,
                          backgroundColor: "red",
                          color: "white",
                        }}
                      >
                        ОБРИШИ ТРАЈНО ({selectedRows.length})
                      </Button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        )}

        {editDataZaposlen && (
          <>
            <div style={{ display: "flex", gap: "10px" }}>
              <div onClick={() => setIsOpenObrazac6(true)}>
                <Button activation={true} style={styles.btn}>
                  ОБРАЗАЦ 6
                </Button>
              </div>
              <div onClick={() => setIsOpenTestBZR(true)}>
                <Button activation={true} style={styles.btn}>
                  TEST BZR
                </Button>
              </div>
              <div onClick={() => setIsOpenZapisnik(true)}>
                <Button activation={true} style={styles.btn}>
                  ЗАПИСНИК
                </Button>
              </div>
              <div onClick={() => setIsOpenIDKartica(true)}>
                <Button activation={true} style={styles.btn}>
                  ИД КАРТА
                </Button>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div onClick={handleNazad}>
                <Button style={{ ...styles.btn, width: "230px" }}>НАЗАД</Button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DokumentaZaposlenih;
